import { BaseEntryScope } from '@/apilib';
import { EditorAPIKey, EditorCoreApiKey } from '@/apis';
import { PromoteStore } from './store';

export class PromoteScope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  editorCoreAPI = this.useDependency(EditorCoreApiKey);
  store = this.declareStore(PromoteStore);
}
